import localeFR from "./uikit.locales/fr.es.js";
function findKeyValue(key) {
  return findKeyValueByRecursion(key.split("."), localeFR.fr);
}
function findKeyValueByRecursion(keys, node) {
  const [key, ...restOfKeys] = keys;
  if (node.hasOwnProperty(key)) {
    const nodePart = node[key];
    if (1 === keys.length) {
      if (typeof nodePart === "string") {
        return nodePart;
      }
    } else {
      return findKeyValueByRecursion(restOfKeys, nodePart);
    }
  }
  return null;
}
function interpolateVariables(traduction, values) {
  if (!values || typeof values !== "object") {
    return traduction;
  }
  let interpolatedTraduction = traduction;
  Object.keys(values).forEach((key) => {
    if (interpolatedTraduction.includes(`{${key}}`) || interpolatedTraduction.includes(`{ ${key} }`)) {
      interpolatedTraduction = interpolatedTraduction.replaceAll(`{${key}}`, values[key]).replaceAll(`{ ${key} }`, values[key]);
    }
  });
  return interpolatedTraduction;
}
function translate(key, values) {
  const traduction = findKeyValue(key);
  if (!traduction) {
    return key;
  }
  return interpolateVariables(traduction, values);
}
function translateTc(key, counter) {
  const traductions = findKeyValue(key);
  if (!traductions || typeof traductions !== "string" || traductions.length === 0) {
    return key;
  }
  const traductionChunk = traductions.split("|");
  let traduction = traductionChunk[0];
  if (traductionChunk.length > 1 && counter > 1) {
    traduction = traductionChunk[1];
  }
  return interpolateVariables(traduction, {});
}
let instance = {
  t: translate,
  tc: translateTc,
  global: {
    t: translate
  }
};
function setupI18nDefault(vueInstance) {
  vueInstance.config.globalProperties.$t = translate;
  vueInstance.config.globalProperties.$_t = translate;
  vueInstance.config.globalProperties.$tc = translateTc;
}
function injectI18n(i18n) {
  instance = i18n;
}
function getI18n() {
  return instance;
}
function getI18nLightInstance() {
  return instance;
}
export {
  getI18n,
  getI18nLightInstance,
  injectI18n,
  setupI18nDefault
};
//# sourceMappingURL=uikit.i18n.es.js.map
